import { adminCustomersLockAllUsersPostSlice } from './post';

export const {
	requestPostAdminCustomersLockAllUsers,
	resetPostAdminCustomersLockAllUsers
} = adminCustomersLockAllUsersPostSlice.asyncActionCreators;
